export const STREAMS_TAB_VALUE_SET = 'STREAMS_TAB_VALUE_SET';

export const STREAM_TYPE_SET = 'STREAM_TYPE_SET';
